export default __webpack_public_path__ + "static/media/4th-seq.6abb4122.jpg";